<template>
  <b-nav-item class="align-items-center exclamation-icon" v-if="importantMessages.length > 0 && importantMessages[0]" @click="toggleToast">
    <i class="icon-info-circle text-danger"></i>
    <b-toast id="important-message-toast-id" v-if="showToast"  :title="messages.getLabelBroadcastMessageTitleAlert()" toaster="b-toaster-top-full" variant="danger" solid no-auto-hide v-model="showToast">
      <ul>
        <li v-for="(segments, index) in importantMessageSegments" :key="index">
          <span v-for="(segment, segmentIndex) in segments" :key="segmentIndex">
            <a v-if="segment.href" :href="segment.href" target="_blank" rel="noopener noreferrer" class="important-message-link">{{ segment.text }}</a>
            <template v-else>{{ segment.text }}</template>
          </span>
        </li>
      </ul>
    </b-toast>
  </b-nav-item>
</template>

<script>
import { messages } from '@/utils/strings'
import { splitTextIntoLinkSegments } from '@/utils/linkify'
export default {
  name: 'ImportantMessageAlert',
  data () {
    return {
      messages,
      showToast: false
    }
  },
  computed: {
    importantMessages () {
      const messages = this.$store.state.profile.importantMessages
      if (messages.length === 1 && messages[0] === '') {
        return []
      }
      return messages
    },
    // KPT-1162: URLs in a message render as links. Segments instead of v-html,
    // so the message text itself is never interpreted as markup.
    importantMessageSegments () {
      return this.importantMessages.map(message => splitTextIntoLinkSegments(message))
    }
  },
  methods: {
    toggleToast () {
      this.showToast = !this.showToast
    }
  }
}
</script>

<style scoped lang="scss">
.exclamation-icon {
  font-size: 1.3rem;
  transform: rotate(180deg);
}

// Bootstrap's .alert-link treatment: the theme link blue is below 4.5:1 on the
// danger toast background, the toast's own text colour is not. :hover as well,
// because the custom.scss prepended to every style block re-declares Bootstrap's
// a:hover here with a higher specificity than this class alone.
.important-message-link {
  font-weight: bold;
  text-decoration: underline;
  overflow-wrap: break-word;

  &,
  &:hover {
    color: inherit;
  }
}
</style>
